/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Invoice status.
 */
export enum InvoiceStatus {
    DRAFT = 'draft',
    SENT = 'sent',
}
